import React from 'react';

const Content: React.FC = ({ children }) => {
  return <div className="AppContent z-20">{children}</div>;
};

export default Content;
